import React, { createContext, useContext, useState } from 'react';

type Ctx = {
  airportId: string | null;
  setAirportId: (id: string | null) => void;
};

const AirportContext = createContext<Ctx | undefined>(undefined);

export function AirportProvider({ children }: { children: React.ReactNode }) {
  const [airportId, setAirportId] = useState<string | null>(null);
  return (
    <AirportContext.Provider value={{ airportId, setAirportId }}>
      {children}
    </AirportContext.Provider>
  );
}

export function useAirport() {
  const ctx = useContext(AirportContext);
  if (!ctx) throw new Error('useAirport must be used within AirportProvider');
  return ctx;
}
